import { Signature, GenerateSignature } from "../models/signature";
import BaseService from "./_base.service";
import API from "../api";

const endpoint = "signature";

const SignatureService = {
  ...BaseService<Signature>({ endpoint }),
  async generate(data: GenerateSignature) {
    return await API.post(`${endpoint + "/signature"}`, data);
  },
};

export default SignatureService;
